/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-domestic': {
    width: 6,
    height: 8,
    viewBox: '0 0 6 8',
    data: '<defs><path pid="0" d="M2.885 7.325c.853 0 1.567-.267 2.14-.8.287-.267.513-.635.68-1.105.167-.47.25-1.022.25-1.655 0-1.02-.275-1.79-.825-2.31-.55-.52-1.315-.78-2.295-.78H.095v.85l.57.03v4.65c0 .167-.097.26-.29.28l-.33.03v.81h2.84zm.02-.96h-1.02v-4.72h.89c1.3 0 1.95.767 1.95 2.3 0 .787-.16 1.387-.48 1.8-.32.413-.767.62-1.34.62z" id="svgicon-icon-status-domestic-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-icon-status-domestic-b" _fill="#fff"><use xlink:href="#svgicon-icon-status-domestic-a"/></mask><use _fill="#404040" fill-rule="nonzero" xlink:href="#svgicon-icon-status-domestic-a"/><path pid="1" _fill="#234357" mask="url(#svgicon-icon-status-domestic-b)" d="M-2-1H8V9H-2z"/></g>'
  }
})
